import styled from "styled-components";

export const ContainerHome = styled.div`
    width: 92%;
    max-width: 400px;

    display: flex;
    align-items: center;
    justify-content: center;

    margin: 50px auto 40px;

    text-align: center;
`